
  document.addEventListener('DOMContentLoaded', initGallery);
  document.addEventListener('shopify:section:load', initGallery);

  function initGallery() {
    if (window.galleryInitialized) return;
    window.galleryInitialized = true;

    var thumbnails = new Splide('#thumbnail-slider', {
      fixedWidth: 50,
      gap: 10,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: false,
    });

    var main = new Splide('#main-slider', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
    });

    main.sync(thumbnails);
    main.mount();
    var totalSlides = main.length;
    document.getElementById('total-slides').innerText = totalSlides;
    document.getElementById('current-slide').innerText = main.index + 1;
    main.on('move', function (newIndex) {
      document.getElementById('current-slide').innerText = newIndex + 1;
    });
    thumbnails.mount();

    var popup = new Splide('#popup-slider', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: true,
      speed: 300, // soft fade
    });

    popup.mount();

document.querySelectorAll('.zoom-container').forEach((container, index) => {
  container.addEventListener('click', function () {
    document.getElementById('gallery-popup').classList.add('active');
    popup.go(0); // or index jodi chai
  });
});
    document.querySelector('#popup-slider').addEventListener('click', function (e) {
      if (e.target.closest('.splide__arrow') || e.target.closest('.close-popup')) return;

      popup.go('>');
    });

    document.querySelector('.close-popup')?.addEventListener('click', function () {
      document.getElementById('gallery-popup').classList.remove('active');
    });

    document.getElementById('gallery-popup')?.addEventListener('click', function (e) {
      if (e.target.id === 'gallery-popup') {
        this.classList.remove('active');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.getElementById('gallery-popup').classList.remove('active');
      }
    });
  }
  document.querySelectorAll('.zoom-container').forEach(container => {

  const img = container.querySelector('img');

  container.addEventListener('mouseenter', () => {
    container.classList.add('zoom-active');

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.src})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );
  });

  container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();

    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    container.style.setProperty(
      '--zoom-position',
      `${x}% ${y}%`
    );

    container.style.setProperty(
      '--zoom-bg',
      `url(${img.currentSrc})`
    );

    container.style.setProperty(
      '--zoom-position',
      `${x}% ${y}%`
    );

    container.style.setProperty(
      '--zoom-position',
      `${x}% ${y}%`
    );

    container.style.setProperty(
      '--zoom-position',
      `${x}% ${y}%`
    );
  });

  container.addEventListener('mouseleave', () => {
    container.classList.remove('zoom-active');
  });

});
